import React from "react";
import DOMPurify from "dompurify";
import AboutDecor from "../../img/decor/about_decor.png";
import ScrollAnimation from 'react-animate-on-scroll';
import 'animate.css';



function EbAutOne({ ebautData }) {

    //console.log(ebautData);

    return (
        <>
            {
                ebautData ?
                    <section className="eut-abot relative mb-[60px] lg:mb-[120px]" id="ebaut">
                        <div className="container max-w-screen-xl mx-auto px-5">

                            <div className="grid grid-cols-1 lg:grid-cols-[calc(60%_-_16px)_calc(40%_-_16px)] gap-10 lg:gap-[32px]">

                                <div className="relative bg-[#c8d2db] py-[45px] px-5 md:p-[40px] xl:p-[50px]">
                                    <p className="text-[#010b13] font-medium mb-8 uppercase relative z-10">про захід</p>
                                    <h2 className="text-[30px] leading-[1.16] uppercase font-bold mb-8 relative z-10">HR Wisdom Summit 2026</h2>
                                    <p className="bg-white uppercase font-medium tracking-[0.15em] p-2 inline-block mb-1 relative z-10">це простір для чесної розмови про людей,</p>
                                    <br />
                                    <p className="bg-white uppercase font-medium tracking-[0.15em] p-2 inline-block mb-6 relative z-10">лідерство та нову культуру роботи в Україні</p>
                                    <p className="text-[#0b131c] leading-[1.2] font-normal relative z-10 max-w-[680px]">Ринок праці в Україні вже не грає за старими правилами: кадровий дефіцит став хронічним, професії змінюються швидше за оргструктури, а HR відповідає не лише за найм, а й за стійкість бізнесу. HR Wisdom Summit 2026 зібрав HRD, CEO та лідерів змін, які щодня перебудовують команди під нову реальність. Без теорії — лише рішення, досвід і чесна розмова про майбутнє роботи в Україні. </p>

                                    <img src={AboutDecor} alt='decor' className="absolute -top-6 -right-4 w-[175px] object-contain
                                        lg:w-[320px] lg:right-28"/>
                                </div>

                                <div className="bg-[#c8d2db] py-4 px-4 h-full text-white overflow-hidden">
                                    <iframe className="w-full h-full min-h-[300px]" src="https://www.youtube.com/embed/OfWDCGTiJKM?si=f1qNOqZQ1EJ4Mlo2" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                                </div>

                            </div>

                        </div>
                    </section> : ''
            }
        </>
    )
}

export default EbAutOne